import { render, staticRenderFns } from "./VerifyManage.vue?vue&type=template&id=dbcb20f8&"
import script from "./VerifyManage.vue?vue&type=script&lang=js&"
export * from "./VerifyManage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports